import { Platform } from "react-native";
import { createGlobalStyle } from 'styled-components';
import FontAwesome300 from "../assets/fonts/FontAwesome/fa-light-300.ttf";
import FontAwesome300_old from "../assets/fonts/FontAwesome/Font Awesome 5 Pro 300.otf";
import FontAwesome400 from "../assets/fonts/FontAwesome/fa-regular-400.ttf";
import FontAwesome400_old from "../assets/fonts/FontAwesome/Font Awesome 5 Pro 400.otf";
import FontAwesome900 from "../assets/fonts/FontAwesome/fa-solid-900.ttf";
import FontAwesome900_old from "../assets/fonts/FontAwesome/Font Awesome 5 Pro 900.otf";

export const GlobalStyle = Platform.OS === 'web' ? createGlobalStyle`
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 300;
    src: url('${FontAwesome300}');
  }
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 300;
    src: url('${FontAwesome300_old}');
  }
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 400;
    src: url('${FontAwesome400}');
  }
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 400;
    src: url('${FontAwesome400_old}');
  }
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 900;
    src: url('${FontAwesome900}');
  }
  @font-face {
    font-family: 'Font Awesome 5 Pro';
    font-weight: 900;
    src: url('${FontAwesome900_old}');
  }
` : () => null;